(function () {
  const DRAWER_ID = 'custom-cart-drawer';
  const ERROR_CLASS = 'custom-cart-add-error';
  const VARIANT_REQUIRED_MESSAGE = 'Please select a product option.';
  const GENERIC_ERROR_MESSAGE = 'Unable to add this item to your cart. Please try again.';
  const CART_UPDATE_ERROR = 'Unable to update your cart. Please try again.';

  const drawer = document.getElementById(DRAWER_ID);
  if (!drawer) return;

  const itemsEl = document.getElementById('cart-drawer-items');
  const titleEl = document.getElementById('cart-drawer-title');
  const subtotalEl = document.getElementById('cart-drawer-subtotal');
  const savingEl = document.getElementById('cart-drawer-saving');
  const summaryEl = document.getElementById('cart-drawer-summary');
  const summaryMrpEl = document.getElementById('cart-drawer-summary-mrp');
  const summaryDiscountEl = document.getElementById('cart-drawer-summary-discount');
  const summarySavingsEl = document.getElementById('cart-drawer-summary-savings');
  const summaryGrandEl = document.getElementById('cart-drawer-summary-grand');
  const summaryDiscountRow = document.getElementById('cart-drawer-summary-discount-row');
  const summarySavingsRow = document.getElementById('cart-drawer-summary-savings-row');
  const summaryBannerEl = document.getElementById('cart-drawer-summary-banner');
  const summaryBannerAmountEl = document.getElementById('cart-drawer-summary-banner-amount');
  const progressHeadingEl = document.getElementById('cart-drawer-progress-heading');
  const progressFillEl = document.getElementById('cart-drawer-progress-fill');
  const progressMarkersEl = document.getElementById('cart-drawer-progress-markers');
  const couponBoxEl = document.getElementById('coupon-box');
  const couponInputEl = document.getElementById('coupon-code-input');
  const couponBtnEl = document.getElementById('coupon-apply-btn');
  const couponMessageEl = document.getElementById('coupon-message');
  const checkoutEl = document.getElementById('cart-drawer-checkout');
  const moneyFormat = drawer.getAttribute('data-money-format') || '{{amount}}';

  const shopifyRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const cartAddUrl = shopifyRoot + 'cart/add.js';
  const cartUrl = shopifyRoot + 'cart.js';
  const cartChangeUrl = shopifyRoot + 'cart/change.js';
  const cartUpdateUrl = shopifyRoot + 'cart/update.js';
  const STEPPER_LOCK_MS = 250;
  const inFlightKeys = new Set();
  const maxQtyByProductId = Object.create(null);
  const noDiscountByProductId = Object.create(null);
  const NO_DISCOUNT_MESSAGE = 'you are not eligible for this discount';

  const rememberItemMaxQty = (item) => {
    const productId = String((item && item.product_id) || '');
    if (!productId) return 0;
    const props = (item && item.properties) || {};
    const max = Number(props._max_qty || props.max_qty || (item && item.max_qty)) || 0;
    if (max > 0) {
      const current = maxQtyByProductId[productId];
      maxQtyByProductId[productId] = current > 0 ? Math.min(current, max) : max;
    }
    return maxQtyByProductId[productId] || 0;
  };

  const rememberNoDiscount = (item) => {
    const productId = String((item && item.product_id) || '');
    if (!productId) return false;
    const props = (item && item.properties) || {};
    const fromProp =
      props._no_discount === true ||
      props._no_discount === 'true' ||
      props._no_discount === '1';
    const fromItem = item && (item.no_discount === true || item.no_discount === 'true');
    if (fromProp || fromItem) noDiscountByProductId[productId] = true;
    return Boolean(noDiscountByProductId[productId]);
  };

  const cartHasNoDiscount = (cart) => {
    const items = (cart && cart.items) || [];
    return items.some((item) => {
      rememberNoDiscount(item);
      return Boolean(noDiscountByProductId[String(item.product_id || '')]);
    });
  };

  const getProductQtyInCart = (cart, productId) => {
    const id = String(productId || '');
    if (!id || !cart || !cart.items) return 0;
    return cart.items.reduce((sum, item) => {
      return String(item.product_id) === id ? sum + (Number(item.quantity) || 0) : sum;
    }, 0);
  };
  const debounce = (fn, wait) => {
    let timer = 0;
    return function () {
      const context = this;
      const args = arguments;
      clearTimeout(timer);
      timer = window.setTimeout(function () {
        fn.apply(context, args);
      }, wait);
    };
  };
  const MILESTONES = [
    { amount: 39900, icon: 'truck', label: 'FREE Delivery' },
    { amount: 69900, icon: 'percent', label: 'Earn 10% Cashback' },
    { amount: 109900, icon: 'gift', label: 'FREE 2N Pads' },
    { amount: 149900, icon: 'gift', label: 'FREE Tote Bag' },
  ];
  const FREE_GIFTS = [
    { sku: 'RCD042', threshold: 149900, title: 'Tote Bag' },
    { sku: 'RC424P', threshold: 109900, title: '2N Pads' },
  ];
  const giftCatalog = {};
  let giftSyncPromise = null;
  const MILESTONE_ICONS = {
    truck:
      '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M3 7h11v10H3V7z" stroke="currentColor" stroke-width="1.75" stroke-linejoin="round"/><path d="M14 10h4.2L21 13.2V17h-7v-7z" stroke="currentColor" stroke-width="1.75" stroke-linejoin="round"/><circle cx="7" cy="18.5" r="1.75" stroke="currentColor" stroke-width="1.75"/><circle cx="17.5" cy="18.5" r="1.75" stroke="currentColor" stroke-width="1.75"/></svg>',
    gift:
      '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><rect x="4" y="9" width="16" height="3.5" rx="0.5" stroke="currentColor" stroke-width="1.75"/><path d="M12 9v11M19 12.5V19a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1v-6.5" stroke="currentColor" stroke-width="1.75" stroke-linejoin="round"/><path d="M8.2 9c-1.8 0-2.7-1.9-1.6-3.2C7.7 4.5 10.2 6.2 12 9c1.8-2.8 4.3-4.5 5.4-3.2 1.1 1.3.2 3.2-1.6 3.2H8.2z" stroke="currentColor" stroke-width="1.75" stroke-linejoin="round"/></svg>',
    percent:
      '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><circle cx="7.5" cy="7.5" r="2.25" stroke="currentColor" stroke-width="1.75"/><circle cx="16.5" cy="16.5" r="2.25" stroke="currentColor" stroke-width="1.75"/><path d="M17.5 6.5 6.5 17.5" stroke="currentColor" stroke-width="1.75" stroke-linecap="round"/></svg>',
  };
  const TRASH_ICON =
    '<svg aria-hidden="true" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">' +
    '<path d="M11.5 9v4.25M8.5 9v4.25M5.75 12.2V6h8.5c0 2.421 0 3.779 0 6.2 0 .853 0 1.447-.038 1.91-.037.453-.106.714-.207.911a2.498 2.498 0 0 1-.983 1.017c-.197.1-.458.17-.911.207-.463.037-1.057.038-1.91.038h-.4c-.853 0-1.447 0-1.91-.038-.453-.037-.714-.106-.911-.207a2.498 2.498 0 0 1-.984-1.017c-.1-.197-.17-.458-.207-.911C5.75 13.647 5.75 13.053 5.75 12.2z" stroke="currentColor" stroke-width="1.25" stroke-linecap="round"/>' +
    '<path d="M4.25 6h11.5M8 5.25a2 2 0 1 1 4 0" stroke="currentColor" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>' +
    '</svg>';

  const NECTOR_BTN_SELECTOR = '.nector-btn, #nector-btn, [class*="nector-btn"], [id*="nector-btn"]';

  const setNectorBtnHidden = (hidden) => {
    document.querySelectorAll(NECTOR_BTN_SELECTOR).forEach((el) => {
      if (el.closest('#custom-cart-drawer')) return;

      if (hidden) {
        if (!el.hasAttribute('data-cart-drawer-prev-inline')) {
          el.setAttribute('data-cart-drawer-prev-inline', el.getAttribute('style') || '');
        }
        el.style.setProperty('display', 'none', 'important');
        el.style.setProperty('visibility', 'hidden', 'important');
        el.style.setProperty('opacity', '0', 'important');
        el.style.setProperty('pointer-events', 'none', 'important');
        el.style.setProperty('z-index', '0', 'important');
        return;
      }

      if (!el.hasAttribute('data-cart-drawer-prev-inline')) return;
      const prev = el.getAttribute('data-cart-drawer-prev-inline');
      el.removeAttribute('data-cart-drawer-prev-inline');
      if (prev) {
        el.setAttribute('style', prev);
      } else {
        el.removeAttribute('style');
      }
    });
  };

  const closePriceSummary = () => {
    if (!summaryEl) return;
    summaryEl.hidden = true;
  };

  const openPriceSummary = () => {
    if (!summaryEl) return;
    summaryEl.hidden = false;
  };

  const startOfferTicker = () => {
    if (drawer.getAttribute('data-ticker-ready') === 'true') return;
    const items = drawer.querySelectorAll('.cart-drawer-ticker__item');
    if (items.length < 2) return;
    drawer.setAttribute('data-ticker-ready', 'true');
    let index = 0;
    setInterval(() => {
      items[index].classList.remove('is-active');
      index = (index + 1) % items.length;
      items[index].classList.add('is-active');
    }, 3000);
  };

  const openDrawer = () => {
    checkoutCartOverride = null;
    startOfferTicker();
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('custom-cart-drawer-open');
    document.body.style.overflow = 'hidden';
    setNectorBtnHidden(true);
  };

  const closeDrawer = () => {
    closePriceSummary();
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('custom-cart-drawer-open');
    document.body.style.overflow = '';
    setNectorBtnHidden(false);
  };

  const updateCartTitle = (count) => {
    if (!titleEl) return;
    const itemCount = Number(count) || 0;
    titleEl.textContent =
      itemCount > 0
        ? 'Your Cart (' + itemCount + (itemCount === 1 ? ' item)' : ' items)')
        : 'Your Cart';
  };

  const syncHeaderCartCount = (cart) => {
    const itemCount = Math.max(0, Number((cart && cart.item_count) || 0));
    const countLabel = itemCount > 0 && itemCount < 100 ? String(itemCount) : itemCount >= 100 ? '' : '0';

    document.dispatchEvent(
      new CustomEvent('cart:update', {
        bubbles: true,
        detail: {
          resource: cart,
          sourceId: DRAWER_ID,
          data: {
            source: 'custom-cart-drawer',
            itemCount: itemCount,
          },
        },
      })
    );

    document.querySelectorAll('cart-icon, .header-actions__cart-icon').forEach((icon) => {
      icon.classList.toggle('header-actions__cart-icon--has-cart', itemCount > 0);

      const bubble = icon.querySelector('[ref="cartBubble"], .cart-bubble');
      const countEl = icon.querySelector('[ref="cartBubbleCount"], .cart-bubble__text-count');

      if (bubble) {
        bubble.classList.toggle('visually-hidden', itemCount === 0);
        if (itemCount <= 99) {
          bubble.setAttribute('data-maintain-ratio', '');
        } else {
          bubble.removeAttribute('data-maintain-ratio');
        }
      }

      if (countEl) {
        countEl.classList.toggle('hidden', itemCount === 0);
        countEl.textContent = countLabel;
      }
    });

    try {
      sessionStorage.setItem(
        'cart-count',
        JSON.stringify({
          value: countLabel,
          timestamp: Date.now(),
        })
      );
    } catch (error) {
      // sessionStorage may be blocked.
    }
  };

  const escapeHtml = (value) =>
    String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');

  const formatMoney = (cents) => {
    const amount = Number(cents) || 0;

    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(amount, moneyFormat);
    }

    const value = (amount / 100).toFixed(2);
    const withCommas = value.replace(/\B(?=(\d{3})+(?!\d))/g, ',');

    return moneyFormat
      .replace(/\{\{\s*amount\s*\}\}/g, withCommas)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, Math.round(amount / 100).toString())
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, value.replace('.', ','))
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, Math.round(amount / 100).toString());
  };

  const getErrorMessage = (payload, fallback) => {
    if (!payload || typeof payload !== 'object') return fallback;

    if (typeof payload.description === 'string' && payload.description.trim()) {
      return payload.description;
    }

    if (typeof payload.message === 'string' && payload.message.trim()) {
      return payload.message;
    }

    if (typeof payload.errors === 'string' && payload.errors.trim()) {
      return payload.errors;
    }

    return fallback;
  };

  const getGiftSku = (item) => {
    const props = readItemProperties(item);
    const propSku = String(props._gift_sku || props._free_gift_sku || '').trim().toUpperCase();
    if (propSku) return propSku;
    const sku = String((item && item.sku) || '').trim().toUpperCase();
    if (isGiftSku(sku)) return sku;
    if (props._free_gift === 'true' || props._virtual_gift === 'true') return sku;
    const variantId = Number(item && (item.variant_id || item.id));
    const matched = FREE_GIFTS.find((gift) => {
      const catalog = giftCatalog[gift.sku];
      return catalog && Number(catalog.variantId) === variantId;
    });
    return matched ? matched.sku : '';
  };

  const isGiftSku = (sku) => FREE_GIFTS.some((gift) => gift.sku === String(sku || '').trim().toUpperCase());

  const readItemProperties = (item) => {
    const props = item && item.properties;
    if (!props) return {};
    if (Array.isArray(props)) {
      return props.reduce((map, entry) => {
        if (!entry) return map;
        const name = entry.name || entry.key;
        if (name) map[name] = entry.value;
        return map;
      }, {});
    }
    return props;
  };

  const isKnownGiftVariant = (item) => {
    const variantId = Number(item && (item.variant_id || item.id));
    if (!variantId) return false;
    return FREE_GIFTS.some((gift) => {
      const catalog = giftCatalog[gift.sku];
      return !!(catalog && Number(catalog.variantId) === variantId);
    });
  };

  const isGiftItem = (item) => {
    if (!item) return false;
    const props = readItemProperties(item);
    if (
      props._free_gift === 'true' ||
      props._virtual_gift === 'true' ||
      Boolean(props._gift_sku) ||
      Boolean(props._free_gift_sku)
    ) {
      return true;
    }
    if (isGiftSku(item.sku)) return true;
    return isKnownGiftVariant(item);
  };

  const getGiftConfig = (sku) =>
    FREE_GIFTS.find((gift) => gift.sku === String(sku || '').trim().toUpperCase());

  const getGiftLineCharge = (item) =>
    Number(item && (item.final_line_price != null ? item.final_line_price : item.line_price)) || 0;

  const isChargedGift = (item) => isGiftItem(item) && getGiftLineCharge(item) > 0;

  const canAddGiftToShopifyCart = (gift) => {
    const catalog = giftCatalog[gift && gift.sku];
    return !!(catalog && catalog.variantId);
  };

  const getSaleLinePrice = (item) => {
    const quantity = Number(item && item.quantity) || 1;
    const originalLine = Number(item && item.original_line_price) || 0;
    if (originalLine > 0) return originalLine;
    const originalUnit = Number(item && item.original_price) || 0;
    if (originalUnit > 0) return originalUnit * quantity;
    return Number(item && (item.line_price != null ? item.line_price : item.price * quantity)) || 0;
  };

  const getPaidSubtotal = (cart) => {
    const items = (cart && cart.items) || [];
    const paidFromItems = items.reduce((sum, item) => {
      if (isGiftItem(item)) return sum;
      return sum + getSaleLinePrice(item);
    }, 0);

    if (items.some((item) => !isGiftItem(item))) {
      return Math.max(0, paidFromItems);
    }

    const giftTotal = items.reduce((sum, item) => {
      if (!isGiftItem(item)) return sum;
      return sum + getGiftLineCharge(item);
    }, 0);

    return Math.max(0, Number((cart && cart.total_price) || 0) - giftTotal);
  };

  const getDiscountedPaidSubtotal = (cart) => {
    const items = (cart && cart.items) || [];
    const discounted = items.reduce((sum, item) => {
      if (isGiftItem(item)) return sum;
      const finalLine = Number(item.final_line_price != null ? item.final_line_price : item.line_price);
      if (Number.isFinite(finalLine) && finalLine >= 0) return sum + finalLine;
      return sum + getSaleLinePrice(item);
    }, 0);

    if (discounted > 0 || items.some((item) => !isGiftItem(item))) {
      return Math.max(0, discounted);
    }

    return Math.max(0, getPaidSubtotal(cart) - (Number((cart && cart.total_discount) || 0)));
  };

  const getDrawerPaidTotal = (cart) => {
    if (Number((cart && cart.total_discount) || 0) > 0) return getDiscountedPaidSubtotal(cart);
    const codes = (cart && cart.discount_codes) || [];
    if (codes.some((entry) => entry && entry.applicable !== false && (entry.code || entry.title))) {
      return getDiscountedPaidSubtotal(cart);
    }
    return getPaidSubtotal(cart);
  };

  const getItemCompareAt = (item) => {
    const quantity = Number(item.quantity) || 1;
    const finalLine = Number(item.final_line_price != null ? item.final_line_price : item.line_price) || 0;
    const originalLine = Number(item.original_line_price) || 0;
    const originalUnit = Number(item.original_price) || 0;
    const catalogUnit = Number(variantCompareCache[item.variant_id || item.id]) || 0;
    const catalogLine = catalogUnit * quantity;

    return Math.max(originalLine, originalUnit * quantity, catalogLine, finalLine);
  };

  const variantCompareCache = {};
  try {
    const compareMapEl = document.getElementById('cart-drawer-compare-map');
    const compareMap = compareMapEl ? JSON.parse(compareMapEl.textContent || '{}') : {};
    Object.keys(compareMap).forEach((id) => {
      variantCompareCache[id] = Number(compareMap[id]) || 0;
      variantCompareCache[Number(id)] = Number(compareMap[id]) || 0;
    });
  } catch (error) {
    // Compare-at map is optional.
  }

  const rememberProductCompares = (product) => {
    ((product && product.variants) || []).forEach((variant) => {
      if (!variant || variant.id == null) return;
      const compareAt = Number(variant.compare_at_price) || 0;
      variantCompareCache[variant.id] = compareAt;
      variantCompareCache[String(variant.id)] = compareAt;
    });
  };

  const ensureCartCompareAts = async (cart) => {
    const handles = {};
    ((cart && cart.items) || []).forEach((item) => {
      const variantId = item.variant_id || item.id;
      if ((variantCompareCache[variantId] == null || variantCompareCache[variantId] === 0) && item.handle) {
        handles[item.handle] = true;
      }
    });

    await Promise.all(
      Object.keys(handles).map(async (handle) => {
        try {
          const response = await fetch(shopifyRoot + 'products/' + handle + '.js', {
            headers: { Accept: 'application/json' },
          });
          if (!response.ok) return;
          rememberProductCompares(await response.json());
        } catch (error) {
          // Keep cart rendering even if compare-at lookup fails.
        }
      })
    );
  };

  const getPaidCompareAt = (cart) =>
    ((cart && cart.items) || []).reduce((sum, item) => {
      if (isGiftItem(item)) return sum;
      return sum + getItemCompareAt(item);
    }, 0);

  const applyNoDiscountIds = (ids) => {
    (ids || []).forEach((id) => {
      const productId = String(id || '');
      if (productId) noDiscountByProductId[productId] = true;
    });
  };

  const fetchNoDiscountIds = async () => {
    try {
      const response = await fetch(shopifyRoot + 'cart?view=nodiscount', {
        method: 'GET',
        headers: { Accept: 'application/json' },
        cache: 'no-store',
      });
      if (!response.ok) return [];
      const data = await response.json();
      return (data && data.ids) || [];
    } catch (error) {
      return [];
    }
  };

  const fetchCartState = async () => {
    readingDrawerCart += 1;
    try {
      const [response, noDiscountIds] = await Promise.all([
        fetch(cartUrl, {
          method: 'GET',
          headers: { Accept: 'application/json' },
          cache: 'no-store',
        }),
        fetchNoDiscountIds(),
      ]);

      if (!response.ok) throw new Error(CART_UPDATE_ERROR);
      const cart = await response.json();
      applyNoDiscountIds(noDiscountIds);
      ((cart && cart.items) || []).forEach((item) => {
        const productId = String(item.product_id || '');
        if (productId && noDiscountByProductId[productId]) item.no_discount = true;
        if (productId && maxQtyByProductId[productId] > 0) item.max_qty = maxQtyByProductId[productId];
        rememberItemMaxQty(item);
      });
      return cart;
    } finally {
      readingDrawerCart -= 1;
    }
  };

  const moneyToCents = (value) => {
    if (typeof value === 'string' && value.indexOf('.') !== -1) {
      const amount = parseFloat(value);
      return Number.isFinite(amount) ? Math.round(amount * 100) : 0;
    }
    const amount = Number(value);
    return Number.isFinite(amount) ? amount : 0;
  };

  const isZeroPriceGift = (variant, product) => {
    if (moneyToCents(variant && variant.price) === 0) return true;
    const tags = product && product.tags;
    const tagText = (Array.isArray(tags) ? tags.join(',') : String(tags || '')).toLowerCase();
    return tagText.indexOf('kwikcart-freebie') !== -1;
  };

  const rememberGiftVariant = (sku, variant, product) => {
    if (!sku || !variant || !variant.id) return;
    const key = String(sku).toUpperCase();
    const price = moneyToCents(variant.price);
    const compareAt = moneyToCents(variant.compare_at_price) || price;
    giftCatalog[key] = {
      sku: key,
      variantId: Number(variant.id),
      title: (getGiftConfig(key) && getGiftConfig(key).title) || variant.name || (product && product.title) || key,
      price: price,
      compareAt: compareAt,
      image: (variant.featured_image && variant.featured_image.src) || (product && product.featured_image) || '',
      freeGiftResolved: true,
    };
  };

  const resolveGiftVariant = async (sku) => {
    const key = String(sku).toUpperCase();
    const cached = giftCatalog[key];
    if (cached && cached.variantId && cached.freeGiftResolved && Number(cached.price) === 0) {
      return cached;
    }

    const matchVariant = (product) =>
      ((product && product.variants) || []).find(
        (entry) => String(entry.sku || '').trim().toUpperCase() === key
      );

    let paidFallback = null;
    const considerProduct = (product) => {
      const variant = matchVariant(product);
      if (!variant) return false;
      if (isZeroPriceGift(variant, product)) {
        rememberGiftVariant(key, variant, product);
        return true;
      }
      if (!paidFallback) paidFallback = { variant: variant, product: product };
      return false;
    };

    try {
      const suggestUrl =
        shopifyRoot +
        'search/suggest.json?q=' +
        encodeURIComponent(sku) +
        '&resources[type]=product&resources[limit]=10&resources[options][unavailable_products]=last';
      const suggestResponse = await fetch(suggestUrl, { headers: { Accept: 'application/json' } });
      const suggestData = await suggestResponse.json().catch(() => null);
      const products =
        (suggestData &&
          suggestData.resources &&
          suggestData.resources.results &&
          suggestData.resources.results.products) ||
        [];

      for (let i = 0; i < products.length; i++) {
        const handle = products[i] && products[i].handle;
        if (!handle) continue;
        const productResponse = await fetch(shopifyRoot + 'products/' + handle + '.js', {
          headers: { Accept: 'application/json' },
        });
        if (!productResponse.ok) continue;
        if (considerProduct(await productResponse.json())) return giftCatalog[key];
      }
    } catch (error) {
      console.warn('[cart-drawer] Could not resolve gift SKU via search', sku, error);
    }

    try {
      const productsResponse = await fetch(shopifyRoot + 'products.json?limit=250', {
        headers: { Accept: 'application/json' },
      });
      const productsData = await productsResponse.json().catch(() => null);
      const products = (productsData && productsData.products) || [];
      for (let i = 0; i < products.length; i++) {
        if (considerProduct(products[i])) return giftCatalog[key];
      }
    } catch (error) {
      console.warn('[cart-drawer] Could not resolve gift SKU via products.json', sku, error);
    }

    if (paidFallback) {
      rememberGiftVariant(key, paidFallback.variant, paidFallback.product);
      return giftCatalog[key];
    }

    return giftCatalog[key] || null;
  };

  const addGiftToCart = async (gift) => {
    const catalog = giftCatalog[gift.sku] || (await resolveGiftVariant(gift.sku));
    if (!catalog || !catalog.variantId) {
      console.warn('[cart-drawer] Missing variant id for gift SKU', gift.sku);
      return false;
    }
    if (Number(catalog.price) > 0) {
      console.warn('[cart-drawer] Skipping paid variant for free gift', gift.sku, catalog.variantId);
      return false;
    }

    const response = await fetch(cartAddUrl, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        id: catalog.variantId,
        quantity: 1,
        properties: {
          _free_gift: 'true',
          _gift_sku: gift.sku,
        },
      }),
    });

    const payload = await response.json().catch(() => null);
    if (!response.ok || (payload && payload.status)) {
      console.warn('[cart-drawer] Could not add free gift', gift.sku, payload);
      return false;
    }

    return true;
  };

  const changeLineQuantity = async (key, quantity) => {
    await fetch(cartChangeUrl, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ id: key, quantity: quantity }),
    });
  };

  const giftLinesForSku = (items, sku) =>
    (items || []).filter((item) => isGiftItem(item) && getGiftSku(item) === sku);

  const syncFreeGifts = async (cart) => {
    if (giftSyncPromise) {
      await giftSyncPromise;
      return fetchCartState();
    }

    giftSyncPromise = (async () => {
      await Promise.all(
        FREE_GIFTS.map(async (gift) => {
          const catalog = giftCatalog[gift.sku];
          if (!catalog || !catalog.freeGiftResolved || Number(catalog.price) > 0) {
            await resolveGiftVariant(gift.sku);
          }
        })
      );

      let current = cart || (await fetchCartState());

      for (let pass = 0; pass < 2; pass++) {
        const paidTotal = getEstimateTotalCents(current);
        const items = current.items || [];
        const adds = [];
        const removes = [];
        const quantityFixes = [];

        FREE_GIFTS.forEach((gift) => {
          const lines = giftLinesForSku(items, gift.sku);
          const shouldHave = paidTotal >= gift.threshold;
          const catalog = giftCatalog[gift.sku];
          const freeVariantId =
            catalog && Number(catalog.price) === 0 ? Number(catalog.variantId) : 0;

          if (shouldHave) {
            const matching = freeVariantId
              ? lines.filter((line) => Number(line.variant_id || line.id) === freeVariantId)
              : lines;
            const stale = freeVariantId
              ? lines.filter((line) => Number(line.variant_id || line.id) !== freeVariantId)
              : [];

            stale.forEach((line) => removes.push(line.key));

            if (!matching.length) {
              if (canAddGiftToShopifyCart(gift)) adds.push(gift);
              return;
            }
            if (Number(matching[0].quantity) !== 1) {
              quantityFixes.push({ key: matching[0].key, quantity: 1 });
            }
            matching.slice(1).forEach((line) => removes.push(line.key));
            return;
          }

          lines.forEach((line) => removes.push(line.key));
        });

        if (!adds.length && !removes.length && !quantityFixes.length) break;

        for (let i = 0; i < quantityFixes.length; i++) {
          await changeLineQuantity(quantityFixes[i].key, quantityFixes[i].quantity);
        }
        for (let i = 0; i < removes.length; i++) {
          await changeLineQuantity(removes[i], 0);
        }
        for (let i = 0; i < adds.length; i++) {
          await addGiftToCart(adds[i]);
        }

        current = await fetchCartState();
      }

      return current;
    })();

    try {
      return await giftSyncPromise;
    } finally {
      giftSyncPromise = null;
    }
  };

  const buildVirtualGiftItems = (cart) => {
    const paidTotal = getEstimateTotalCents(cart);
    const items = (cart && cart.items) || [];

    return FREE_GIFTS.reduce((list, gift) => {
      if (paidTotal < gift.threshold) return list;

      const hasLine = giftLinesForSku(items, gift.sku).length > 0;
      if (hasLine) return list;

      const catalog = giftCatalog[gift.sku] || {};
      list.push({
        key: 'virtual-gift-' + gift.sku,
        sku: gift.sku,
        product_title: gift.title,
        title: gift.title,
        quantity: 1,
        price: 0,
        original_price: Number(catalog.compareAt) || Number(catalog.price) || 0,
        image: catalog.image || '',
        featured_image: catalog.image ? { url: catalog.image } : null,
        properties: { _free_gift: 'true', _gift_sku: gift.sku, _virtual_gift: 'true' },
        variant_id: catalog.variantId || '',
      });
      return list;
    }, []);
  };

  const GIFT_MONEY_KEYS = [
    'price',
    'original_price',
    'discounted_price',
    'line_price',
    'original_line_price',
    'final_price',
    'final_line_price',
    'compare_at_price',
    'compare_at_line_price',
    'total_discount',
    'line_level_total_discount',
    'presentment_price',
    'pre_tax_price',
    'total_price',
  ];

  const zeroGiftMoneyFields = (item) => {
    if (!isGiftItem(item)) return item;
    const zeroed = Object.assign({}, item);
    GIFT_MONEY_KEYS.forEach((key) => {
      if (key in zeroed) zeroed[key] = 0;
    });
    zeroed.price = 0;
    zeroed.original_price = 0;
    zeroed.discounted_price = 0;
    zeroed.line_price = 0;
    zeroed.original_line_price = 0;
    zeroed.final_price = 0;
    zeroed.final_line_price = 0;
    zeroed.compare_at_price = 0;
    zeroed.compare_at_line_price = 0;
    zeroed.total_discount = 0;
    zeroed.line_level_total_discount = 0;
    zeroed.discounts = [];
    zeroed.discount_allocations = [];
    zeroed.line_level_discount_allocations = [];
    if (zeroed.presentment_prices && Array.isArray(zeroed.presentment_prices)) {
      zeroed.presentment_prices = zeroed.presentment_prices.map((entry) => {
        if (!entry || typeof entry !== 'object') return entry;
        const next = Object.assign({}, entry);
        if (next.price && typeof next.price === 'object') {
          next.price = Object.assign({}, next.price, { amount: '0.0', currency_code: next.price.currency_code });
        }
        if (next.compare_at_price && typeof next.compare_at_price === 'object') {
          next.compare_at_price = Object.assign({}, next.compare_at_price, {
            amount: '0.0',
            currency_code: next.compare_at_price.currency_code,
          });
        }
        if (typeof next.price === 'number' || typeof next.price === 'string') next.price = 0;
        if (typeof next.compare_at_price === 'number' || typeof next.compare_at_price === 'string') {
          next.compare_at_price = 0;
        }
        return next;
      });
    }
    return zeroed;
  };

  const rewriteCartGiftPrices = (cart, options) => {
    if (!cart || !Array.isArray(cart.items)) return cart;

    const paid = getPaidSubtotal(cart);
    const giftTotal = getEstimateTotalCents(cart);
    const keepUnearned = !!(options && options.keepUnearned);
    const items = cart.items
      .filter((item) => {
        if (!isGiftItem(item)) return true;
        if (keepUnearned) return true;
        const config = getGiftConfig(getGiftSku(item));
        return !!(config && giftTotal >= config.threshold);
      })
      .map((item) => (isGiftItem(item) ? zeroGiftMoneyFields(item) : item));

    return Object.assign({}, cart, {
      items: items,
      item_count: items.reduce((count, item) => count + (Number(item.quantity) || 0), 0),
      total_price: paid,
      items_subtotal_price: paid,
      original_total_price: paid,
      total_discount: Number(cart.total_discount || 0),
    });
  };

  const attachCheckoutGifts = (cart) => {
    if (!cart || !Array.isArray(cart.items)) return cart;
    const extras = buildVirtualGiftItems(cart).map((item) => zeroGiftMoneyFields(item));
    if (!extras.length) return cart;
    const items = cart.items.concat(extras);
    return Object.assign({}, cart, {
      items: items,
      item_count: items.reduce((count, item) => count + (Number(item.quantity) || 0), 0),
    });
  };

  const neutralizeChargedGiftsForCheckout = async (cart) => {
    const current = cart || (await fetchCartState());
    const charged = ((current && current.items) || []).filter(isChargedGift);
    if (!charged.length) return current;
    for (let i = 0; i < charged.length; i++) {
      await changeLineQuantity(charged[i].key, 0);
    }
    return fetchCartState();
  };

  const buildCheckoutCart = (cart) =>
    attachCheckoutGifts(applySummarySubtotalToCheckout(rewriteCartGiftPrices(cart)));

  let checkoutCartOverride = null;
  let checkoutFetchPatched = false;
  let readingDrawerCart = 0;

  const cartPayloadForConsumer = (cart) =>
    readingDrawerCart > 0 ? rewriteCartGiftPrices(cart, { keepUnearned: true }) : buildCheckoutCart(cart);

  const isCartPayloadUrl = (url) => {
    try {
      const parsed = new URL(String(url || ''), window.location.origin);
      return /\/cart(?:\/(?:change|update|clear))?\.(?:js|json)$/i.test(parsed.pathname);
    } catch (error) {
      return /\/cart(?:\/(?:change|update|clear))?\.(?:js|json)(\?|$)/i.test(String(url || ''));
    }
  };

  const isShopifyCartPayload = (data) =>
    !!(data && Array.isArray(data.items) && typeof data.total_price === 'number' && !data.status);

  const cartJsonResponse = (cart, status) =>
    new Response(JSON.stringify(cart), {
      status: status || 200,
      headers: { 'Content-Type': 'application/json' },
    });

  const publishCheckoutCart = (cart) => {
    const checkoutCart = buildCheckoutCart(cart);
    checkoutCartOverride = checkoutCart;
    window.cart = checkoutCart;
    return checkoutCart;
  };

  const ensureCheckoutFetchPatch = () => {
    if (checkoutFetchPatched) return;
    checkoutFetchPatched = true;
    const nativeFetch = window.fetch.bind(window);

    window.fetch = function (input, init) {
      const url = typeof input === 'string' ? input : (input && input.url) || '';
      if (!isCartPayloadUrl(url)) return nativeFetch(input, init);

      return nativeFetch(input, init).then(async (response) => {
        try {
          const data = await response.clone().json();
          if (!isShopifyCartPayload(data)) return response;
          return cartJsonResponse(cartPayloadForConsumer(data), response.status);
        } catch (error) {
          return response;
        }
      });
    };

    const xhrOpen = XMLHttpRequest.prototype.open;
    const xhrSend = XMLHttpRequest.prototype.send;

    XMLHttpRequest.prototype.open = function (method, url) {
      this.__cartPayloadUrl = url;
      return xhrOpen.apply(this, arguments);
    };

    XMLHttpRequest.prototype.send = function () {
      if (!isCartPayloadUrl(this.__cartPayloadUrl)) {
        return xhrSend.apply(this, arguments);
      }

      const xhr = this;
      const applyGiftZero = () => {
        if (xhr.readyState !== 4 || xhr.__giftPricesZeroed) return;
        try {
          const data = JSON.parse(xhr.responseText);
          if (!isShopifyCartPayload(data)) return;
          const payload = JSON.stringify(cartPayloadForConsumer(data));
          xhr.__giftPricesZeroed = true;
          Object.defineProperty(xhr, 'responseText', { configurable: true, get: () => payload });
          Object.defineProperty(xhr, 'response', { configurable: true, get: () => payload });
        } catch (error) {
          // Keep the original cart payload if rewriting fails.
        }
      };

      xhr.addEventListener('readystatechange', applyGiftZero);
      xhr.addEventListener('load', applyGiftZero);

      return xhrSend.apply(this, arguments);
    };
  };

  ensureCheckoutFetchPatch();

  const ensureEarnedGiftsInShopifyCart = async (cart) => {
    let current = await syncFreeGifts(cart);
    const paidTotal = getEstimateTotalCents(current);

    for (let i = 0; i < FREE_GIFTS.length; i++) {
      const gift = FREE_GIFTS[i];
      if (paidTotal < gift.threshold) continue;
      let catalog = giftCatalog[gift.sku];
      if (!catalog || !catalog.freeGiftResolved || Number(catalog.price) > 0) {
        catalog = await resolveGiftVariant(gift.sku);
      }
      const freeVariantId = catalog && Number(catalog.price) === 0 ? Number(catalog.variantId) : 0;
      const lines = giftLinesForSku(current.items || [], gift.sku);
      const stale = freeVariantId
        ? lines.filter((line) => Number(line.variant_id || line.id) !== freeVariantId)
        : [];
      for (let j = 0; j < stale.length; j++) {
        await changeLineQuantity(stale[j].key, 0);
      }
      const hasFreeLine = freeVariantId
        ? lines.some((line) => Number(line.variant_id || line.id) === freeVariantId)
        : lines.length > 0 && !stale.length;
      if (!hasFreeLine) await addGiftToCart(gift);
      if (stale.length || !hasFreeLine) current = await fetchCartState();
    }

    return fetchCartState();
  };

  const prepareCheckoutCart = async () => {
    ensureCheckoutFetchPatch();
    let cart = await fetchCartState();
    cart = await ensureEarnedGiftsInShopifyCart(cart);
    cart = await neutralizeChargedGiftsForCheckout(cart);
    return publishCheckoutCart(cart);
  };

  const sizedCartImage = (src) => {
    if (!src) return '';
    try {
      const url = new URL(src, window.location.origin);
      url.searchParams.set('width', '140');
      return url.href;
    } catch (error) {
      return src;
    }
  };

  const itemImageHtml = (item) => {
    const src = (item && (item.image || (item.featured_image && item.featured_image.url))) || '';
    const alt = escapeHtml(item.product_title || item.title || '');

    if (!src) {
      return '<div class="cart-drawer-item__image-placeholder" aria-hidden="true"></div>';
    }

    return (
      '<img class="cart-drawer-item__image" src="' +
      escapeHtml(sizedCartImage(src)) +
      '" alt="' +
      alt +
      '" width="70" height="70" loading="eager" decoding="async">'
    );
  };

  const buildPriceBlockHtml = (item) => {
    const saleLine = getSaleLinePrice(item);
    const compareAt = getItemCompareAt(item);
    const hasDiscount = compareAt > saleLine && compareAt > 0;
    const percentOff = hasDiscount ? Math.round(((compareAt - saleLine) / compareAt) * 100) : 0;

    let html = '<div class="cart-drawer-item__price-block">';

    if (hasDiscount) {
      html +=
        '<span class="cart-drawer-item__price-original">M.R.P: ' +
        escapeHtml(formatMoney(compareAt)) +
        '</span>';
    }

    html +=
      '<span class="cart-drawer-item__price-current">' +
      (hasDiscount ? '' : 'M.R.P: ') +
      escapeHtml(formatMoney(saleLine)) +
      '</span>';

    if (hasDiscount && percentOff > 0) {
      html += '<span class="cart-drawer-item__price-off">(' + percentOff + '% OFF)</span>';
    }

    html += '</div>';
    return html;
  };

  const itemHtml = (item, cart) => {
    const key = escapeHtml(item.key);
    const rawTitle = item.product_title || item.title || '';
    const title = escapeHtml(rawTitle);
    const url = escapeHtml(item.url || '#');
    const variantTitle = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
    const productId = item.product_id || '';
    const festiveBundle = isFestiveBundleTitle(rawTitle);
    let maxQty = rememberItemMaxQty(item);
    if (festiveBundle) maxQty = 1;
    rememberNoDiscount(item);
    const usedQty = maxQty === 4 ? Number(item.quantity) || 0 : getProductQtyInCart(cart, productId);
    const plusDisabled = maxQty > 0 && usedQty >= maxQty;

    if (isGiftItem(item)) {
      const sku = getGiftSku(item);
      const config = getGiftConfig(sku);
      const catalog = giftCatalog[sku] || {};
      const giftTitle = escapeHtml(
        (config && config.title) || item.product_title || item.title || 'Free gift'
      );
      const compareAt =
        Number(catalog.compareAt) || Number(item.original_price) || Number(item.price) || 0;

      return (
        '<div class="cart-drawer-item cart-drawer-item--gift" data-key="' +
        key +
        '" data-gift-sku="' +
        escapeHtml(sku) +
        '">' +
        itemImageHtml(item) +
        '<div class="cart-drawer-item__content">' +
        '<div class="cart-drawer-item__top">' +
        '<div class="cart-drawer-item__details">' +
        '<div class="cart-drawer-item__title">' +
        '<span class="cart-drawer-item__gift-mark" aria-hidden="true">🎁</span>' +
        '<span>' +
        giftTitle +
        '</span>' +
        '</div>' +
        '</div>' +
        '<div class="cart-drawer-item__price-block">' +
        (compareAt > 0
          ? '<span class="cart-drawer-item__price-original">M.R.P: ' + escapeHtml(formatMoney(compareAt)) + '</span>'
          : '') +
        '<span class="cart-drawer-item__price-free">FREE</span>' +
        '</div>' +
        '</div>' +
        '<div class="cart-drawer-item__actions">' +
        '<span class="cart-drawer-item__qty-static" aria-label="Quantity 1">1</span>' +
        '</div>' +
        '</div>' +
        '</div>'
      );
    }

    return (
      '<div class="cart-drawer-item" data-key="' +
      key +
      '" data-product-id="' +
      escapeHtml(String(productId)) +
      '">' +
      itemImageHtml(item) +
      '<div class="cart-drawer-item__content">' +
      '<div class="cart-drawer-item__top">' +
      '<div class="cart-drawer-item__details">' +
      '<a class="cart-drawer-item__title" href="' +
      url +
      '">' +
      title +
      '</a>' +
      (variantTitle ? '<p class="cart-drawer-item__variant">' + escapeHtml(variantTitle) + '</p>' : '') +
      '</div>' +
      buildPriceBlockHtml(item) +
      '</div>' +
      '<div class="cart-drawer-item__actions">' +
      '<div class="qty-stepper" data-key="' +
      key +
      '" data-quantity="' +
      Number(item.quantity) +
      '" data-max-qty="' +
      maxQty +
      '">' +
      '<button class="qty-stepper__btn qty-stepper__minus" type="button" data-qty-minus data-key="' +
      key +
      '" aria-label="Decrease quantity">' +
      '&minus;' +
      '</button>' +
      '<span class="qty-stepper__value" data-qty-value>' +
      Number(item.quantity) +
      '</span>' +
      '<button class="qty-stepper__btn qty-stepper__plus" type="button" data-qty-plus data-key="' +
      key +
      '" aria-label="Increase quantity"' +
      (plusDisabled ? ' disabled' : '') +
      '>' +
      '+' +
      '</button>' +
      '</div>' +
      '<button class="cart-drawer-item__remove" type="button" data-cart-remove data-key="' +
      key +
      '" aria-label="Remove ' +
      title +
      '">' +
      TRASH_ICON +
      '</button>' +
      '</div>' +
      '</div>' +
      '</div>'
    );
  };

  const emptyCartHtml =
    '<div class="cart-drawer-empty">' +
    '<p class="cart-drawer-empty-title">Your cart is empty</p>' +
    '<button class="cart-drawer-continue" type="button" data-cart-drawer-close>Continue shopping</button>' +
    '</div>';

  let cachedCart = null;
  try {
    const bootEl = document.getElementById('cart-drawer-boot');
    cachedCart = bootEl ? JSON.parse(bootEl.textContent || 'null') : null;
  } catch (error) {
    cachedCart = null;
  }

  if (cachedCart && cachedCart.items) {
    cachedCart.items.forEach((item) => {
      rememberItemMaxQty(item);
      rememberNoDiscount(item);
    });
  }

  const paintCart = (cart) => {
    if (!itemsEl) return cart;

    cachedCart = cart;
    initProgressBar();
    const paidTotal = getEstimateTotalCents(cart);
    const visibleItems = (cart.items || []).filter((item) => {
      if (!isGiftItem(item)) return true;
      const config = getGiftConfig(getGiftSku(item));
      return !!(config && paidTotal >= config.threshold);
    });
    const virtualGifts = buildVirtualGiftItems(cart);
    const renderItems = visibleItems.concat(virtualGifts);
    const isEmpty = !renderItems.length;

    drawer.classList.toggle('is-empty', isEmpty);
    itemsEl.innerHTML = isEmpty ? emptyCartHtml : renderItems.map((item) => itemHtml(item, cart)).join('');
    updateCartTitle(renderItems.reduce((count, item) => count + (Number(item.quantity) || 0), 0));
    updateEstimatedTotal(cart);
    syncHeaderCartCount(cart);
    updateProgressBar(cart);
    syncCouponFromCart(cart);

    document.dispatchEvent(
      new CustomEvent('custom-cart:updated', {
        detail: { cart },
      })
    );

    return cart;
  };

  const showItemError = (item, message) => {
    if (!item) return;

    let errorEl = item.querySelector('.cart-drawer-item__error');
    if (!errorEl) {
      errorEl = document.createElement('p');
      errorEl.className = 'cart-drawer-item__error';
      errorEl.setAttribute('role', 'alert');
      const details = item.querySelector('.cart-drawer-item__details');
      if (details) details.appendChild(errorEl);
    }

    errorEl.textContent = message;
  };

  const splitMilestoneLabel = (label) => {
    const parts = String(label || '').trim().split(/\s+/);
    if (parts[0] && parts[0].toUpperCase() === 'FREE') {
      return { eyebrow: 'FREE', name: parts.slice(1).join(' ') };
    }
    return { eyebrow: '', name: label };
  };

  const PROGRESS_ICON_START = 20;

  const getMilestonePosition = (index) => {
    const lastIndex = MILESTONES.length - 1;
    if (lastIndex <= 0) return PROGRESS_ICON_START;
    return PROGRESS_ICON_START + (index / lastIndex) * (100 - PROGRESS_ICON_START);
  };

  const initProgressBar = () => {
    if (!progressMarkersEl || !MILESTONES.length || progressMarkersEl.getAttribute('data-ready') === 'true') return;

    const lastIndex = MILESTONES.length - 1;

    progressMarkersEl.innerHTML = MILESTONES.map((milestone, index) => {
      const position = getMilestonePosition(index);
      const edge = index === 0 ? 'start' : index === lastIndex ? 'end' : 'mid';
      const parts = splitMilestoneLabel(milestone.label);
      const icon = MILESTONE_ICONS[milestone.icon] || MILESTONE_ICONS.gift;

      return (
        '<div class="cart-drawer-progress__marker" data-edge="' +
        edge +
        '" style="left:' +
        position +
        '%">' +
        '<span class="cart-drawer-progress__amount">' +
        escapeHtml(formatMoney(milestone.amount)) +
        '</span>' +
        '<span class="cart-drawer-progress__icon">' +
        icon +
        '</span>' +
        '<span class="cart-drawer-progress__label">' +
        (parts.eyebrow
          ? '<span class="cart-drawer-progress__label-eyebrow">' + escapeHtml(parts.eyebrow) + '</span>'
          : '') +
        '<span class="cart-drawer-progress__label-name">' +
        escapeHtml(parts.name).replace(/2N Pads/gi, '2N<br>Pads') +
        '</span>' +
        '</span>' +
        '</div>'
      );
    }).join('');
    progressMarkersEl.setAttribute('data-ready', 'true');
  };

  const updateProgressBar = (cart) => {
    const total = getEstimateTotalCents(cart);
    const lastIndex = MILESTONES.length - 1;
    let fillPercent = 100;

    if (total <= 0) {
      fillPercent = 0;
    } else if (total < MILESTONES[0].amount) {
      fillPercent = (total / MILESTONES[0].amount) * getMilestonePosition(0);
    } else {
      for (let i = 0; i < lastIndex; i++) {
        const startAmount = MILESTONES[i].amount;
        const endAmount = MILESTONES[i + 1].amount;
        if (total <= endAmount) {
          const startPos = getMilestonePosition(i);
          const endPos = getMilestonePosition(i + 1);
          fillPercent =
            startPos + ((total - startAmount) / (endAmount - startAmount)) * (endPos - startPos);
          break;
        }
      }
    }

    fillPercent = Math.max(0, Math.min(100, fillPercent));

    if (progressFillEl) {
      progressFillEl.style.transform = 'scaleX(' + fillPercent / 100 + ')';
    }

    if (progressMarkersEl) {
      const markers = progressMarkersEl.querySelectorAll('.cart-drawer-progress__marker');
      markers.forEach((marker, index) => {
        const milestone = MILESTONES[index];
        marker.classList.toggle('is-achieved', !!(milestone && total >= milestone.amount));
      });
    }

    if (!progressHeadingEl) return;

    const nextMilestone = MILESTONES.find((milestone) => total < milestone.amount);

    if (!nextMilestone) {
      progressHeadingEl.textContent = "You've unlocked all rewards!";
      return;
    }

    const remaining = nextMilestone.amount - total;
    progressHeadingEl.textContent =
      'Add ' + formatMoney(remaining) + ' more to unlock ' + nextMilestone.label;
  };

  const couponState = {
    inFlight: false,
    appliedCode: '',
    showingError: false,
    suppressAutoCoupon: false,
  };

  const AUTO_COUPON_CODE = 'STEAL30';
  const AUTO_COUPON_CODES = {
    STEAL30: true,
    PAYDAY30: true,
  };

  const isAutoCouponCode = (code) => {
    const normalized = String(code || '')
      .replace(/\s+/g, '')
      .toUpperCase();
    return AUTO_COUPON_CODES[normalized] === true;
  };
  const PAYDAY_BLOCKED_SKUS = {
    RC021A: true,
    RC039P: true,
    RC038: true,
    RC040: true,
    RC049P: true,
    RC434: true,
    RC465P: true,
  };

  const isPaydayBlockedSku = (sku) =>
    PAYDAY_BLOCKED_SKUS[String(sku || '').trim().toUpperCase()] === true;

  const isPaydayEligibleLine = (item) => {
    if (!item || isGiftItem(item)) return false;
    if (rememberNoDiscount(item)) return false;
    if (isPaydayBlockedSku(item.sku)) return false;
    return getSaleLinePrice(item) > 0;
  };

  const isFestiveBundleTitle = (value) => {
    const title = String(value || '')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();
    return title === 'festive bundle' || title.indexOf('festive bundle') === 0;
  };

  const cartHasFestiveBundle = (cart) => {
    const inCart = ((cart && cart.items) || []).some((item) =>
      isFestiveBundleTitle((item && (item.product_title || item.title)) || '')
    );
    if (inCart) return true;
    if (!itemsEl) return false;
    return Array.from(itemsEl.querySelectorAll('.cart-drawer-item__title')).some((node) =>
      isFestiveBundleTitle(node.textContent)
    );
  };

  const paydayLinePayable = (sale) => Math.round((Number(sale) * 70) / 100);

  const getPaydayDiscountCents = (cart) => {
    if (cartHasFestiveBundle(cart)) return 0;
    if (couponState.suppressAutoCoupon || couponState.showingError) return 0;
    if (cartHasNoDiscount(cart)) return 0;
    if (getAppliedCoupon(cart)) return 0;
    if (Number((cart && cart.total_discount) || 0) > 0) return 0;

    let off = 0;
    ((cart && cart.items) || []).forEach((item) => {
      if (!isPaydayEligibleLine(item)) return;
      const sale = getSaleLinePrice(item);
      off += sale - paydayLinePayable(sale);
    });
    return off;
  };

  const getEstimateTotalCents = (cart) =>
    Math.max(0, getDrawerPaidTotal(cart) - getPaydayDiscountCents(cart));

  const getSummarySubtotalCents = (cart) => {
    const current = getEstimateTotalCents(cart);
    const compare = getPaidCompareAt(cart);
    return compare > current ? compare : current;
  };

  const applySummarySubtotalToCheckout = (cart) => {
    if (!cart || !Array.isArray(cart.items)) return cart;
    if (getPaydayDiscountCents(cart) <= 0) return cart;

    const subtotal = getSummarySubtotalCents(cart);
    const estimate = getEstimateTotalCents(cart);
    const useCompare = subtotal > estimate;
    const items = cart.items.map((item) => {
      if (!useCompare || isGiftItem(item)) return item;
      const quantity = Number(item.quantity) || 1;
      const line = getItemCompareAt(item);
      const unit = quantity > 0 ? Math.round(line / quantity) : line;
      return Object.assign({}, item, {
        price: unit,
        original_price: unit,
        discounted_price: unit,
        line_price: line,
        original_line_price: line,
        final_price: unit,
        final_line_price: line,
        total_discount: 0,
        line_level_total_discount: 0,
        discounts: [],
        discount_allocations: [],
        line_level_discount_allocations: [],
      });
    });
    const paid = items.reduce((sum, item) => {
      if (isGiftItem(item)) return sum;
      return sum + (Number(item.final_line_price != null ? item.final_line_price : item.line_price) || 0);
    }, 0);

    return Object.assign({}, cart, {
      items: items,
      total_price: useCompare ? paid : subtotal,
      items_subtotal_price: useCompare ? paid : subtotal,
      original_total_price: useCompare ? paid : subtotal,
      total_discount: 0,
      discount_codes: [],
      cart_level_discount_applications: [],
      discount_applications: [],
    });
  };

  const getDiscountTitle = (entry) => {
    if (!entry) return '';
    if (typeof entry === 'string') return entry.trim();
    const app = entry.discount_application || entry;
    return String(app.code || app.title || entry.code || entry.title || '').trim();
  };

  const getApplicableDiscountCodes = (cart) => {
    const codes = (cart && cart.discount_codes) || [];
    return codes
      .filter((entry) => entry && (entry.applicable !== false) && (entry.code || entry.title))
      .map((entry) => String(entry.code || entry.title));
  };

  const getAppliedCoupon = (cart) => {
    const codes = getApplicableDiscountCodes(cart);
    if (codes.length) return codes[0];

    const fromApps = []
      .concat((cart && cart.cart_level_discount_applications) || [])
      .concat((cart && cart.discount_applications) || [])
      .map(getDiscountTitle)
      .filter(Boolean);
    if (fromApps.length) return fromApps[0];

    const items = (cart && cart.items) || [];
    for (let i = 0; i < items.length; i++) {
      const item = items[i];
      if (isGiftItem(item)) continue;
      const lineApps = []
        .concat(item.line_level_discount_allocations || [])
        .concat(item.discount_allocations || [])
        .concat(item.discounts || []);
      for (let j = 0; j < lineApps.length; j++) {
        const title = getDiscountTitle(lineApps[j]);
        if (title) return title;
      }
    }

    const attributes = (cart && cart.attributes) || {};
    return String(attributes.coupon_code || attributes.discount_code || '').trim();
  };

  const cartHasAnyDiscount = (cart) => {
    if (getAppliedCoupon(cart)) return true;
    return Number((cart && cart.total_discount) || 0) > 0;
  };

  const isCouponApplicable = (cart, code) => {
    const target = String(code || '').trim().toLowerCase();
    if (!target) return false;
    const codes = (cart && cart.discount_codes) || [];
    return codes.some(
      (entry) => entry && entry.applicable && String(entry.code || '').toLowerCase() === target
    );
  };

  const setCouponMessage = (text, type) => {
    if (!couponMessageEl) return;
    if (!text) {
      couponMessageEl.hidden = true;
      couponMessageEl.textContent = '';
      couponMessageEl.classList.remove('is-success', 'is-error');
      return;
    }
    couponMessageEl.hidden = false;
    couponMessageEl.textContent = text;
    couponMessageEl.classList.toggle('is-success', type === 'success');
    couponMessageEl.classList.toggle('is-error', type === 'error');
  };

  const setCouponButton = (mode) => {
    if (!couponBtnEl) return;
    couponBtnEl.disabled = mode === 'loading';
    couponBtnEl.classList.toggle('is-remove', mode === 'remove');

    if (mode === 'loading') {
      couponBtnEl.setAttribute('aria-label', 'Applying coupon');
      couponBtnEl.innerHTML = '<span class="coupon-box__spinner" aria-hidden="true"></span>';
      return;
    }

    couponBtnEl.textContent = mode === 'remove' ? 'Remove' : 'Apply';
    couponBtnEl.setAttribute('aria-label', mode === 'remove' ? 'Remove coupon' : 'Apply coupon');
  };

  const setCouponIdleUI = () => {
    couponState.appliedCode = '';
    couponState.showingError = false;
    if (couponBoxEl) couponBoxEl.classList.remove('is-error', 'is-applied');
    if (couponInputEl && document.activeElement !== couponInputEl) {
      couponInputEl.value = '';
    }
    if (couponInputEl) couponInputEl.readOnly = false;
    setCouponButton('apply');
    setCouponMessage('', '');
  };

  const setCouponAppliedUI = (code) => {
    couponState.appliedCode = code;
    couponState.showingError = false;
    if (couponBoxEl) {
      couponBoxEl.classList.remove('is-error');
      couponBoxEl.classList.add('is-applied');
    }
    if (couponInputEl) {
      couponInputEl.value = code;
      couponInputEl.readOnly = true;
    }
    setCouponButton('remove');
    setCouponMessage('Coupon ' + code + ' applied', 'success');
  };

  const setCouponErrorUI = (code, message) => {
    couponState.appliedCode = '';
    couponState.showingError = true;
    if (couponBoxEl) {
      couponBoxEl.classList.add('is-error');
      couponBoxEl.classList.remove('is-applied');
    }
    if (couponInputEl) {
      couponInputEl.readOnly = false;
      if (code) couponInputEl.value = code;
    }
    setCouponButton('apply');
    setCouponMessage(message || 'This coupon code is invalid or expired', 'error');
  };

  const updateCheckoutLink = (code) => {
    if (!checkoutEl) return;
    if (cartHasNoDiscount(cachedCart)) {
      checkoutEl.href = shopifyRoot + 'checkout';
      return;
    }
    checkoutEl.href = code
      ? shopifyRoot + 'checkout?discount=' + encodeURIComponent(code)
      : shopifyRoot + 'checkout';
  };

  const getGokwikCheckoutButton = () => {
    const localButton = drawer.querySelector('.gokwik-checkout button');
    if (localButton) return localButton;
    return document.querySelector('.gokwik-checkout button, #gokwik-buy-now');
  };

  const startGokwikCheckout = async (event) => {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }

    try {
      await prepareCheckoutCart();
    } catch (error) {
      // Still open checkout even if gift cleanup fails.
    }

    const gokwikButton = getGokwikCheckoutButton();
    closeDrawer();

    if (gokwikButton && typeof window.onCheckoutNow === 'function') {
      window.onCheckoutNow(gokwikButton);
      return;
    }

    if (typeof window.onCheckoutClick === 'function') {
      window.onCheckoutClick(gokwikButton || checkoutEl);
      return;
    }

    if (gokwikButton && typeof window.onBuyNowClick === 'function') {
      window.onBuyNowClick(gokwikButton);
      return;
    }

    window.location.href = (checkoutEl && checkoutEl.getAttribute('href')) || shopifyRoot + 'checkout';
  };

  const updateEstimatedTotal = (cart) => {
    const current = getEstimateTotalCents(cart);
    const compare = getPaidCompareAt(cart);
    const savings = Math.max(0, compare - current);
    const hasDiscount = savings > 0;

    if (subtotalEl) {
      subtotalEl.textContent = formatMoney(current);
    }

    if (savingEl) {
      savingEl.hidden = !hasDiscount;
      savingEl.textContent = hasDiscount ? 'SAVING ' + formatMoney(savings) : '';
    }

    if (summaryMrpEl) {
      summaryMrpEl.textContent = formatMoney(hasDiscount ? compare : current);
    }

    if (summaryGrandEl) {
      summaryGrandEl.textContent = formatMoney(current);
    }

    if (summaryDiscountRow && summaryDiscountEl) {
      summaryDiscountRow.hidden = !hasDiscount;
      summaryDiscountEl.textContent = hasDiscount ? '-' + formatMoney(savings) : '';
    }

    if (summarySavingsRow && summarySavingsEl) {
      summarySavingsRow.hidden = !hasDiscount;
      summarySavingsEl.textContent = hasDiscount ? '-' + formatMoney(savings) : '';
    }

    if (summaryBannerEl) {
      summaryBannerEl.hidden = !hasDiscount;
      if (summaryBannerAmountEl) {
        summaryBannerAmountEl.textContent = formatMoney(savings);
      }
    }
  };

  const syncCouponFromCart = (cart) => {
    const applied = getAppliedCoupon(cart);
    const visualPayday = getPaydayDiscountCents(cart) > 0;
    updateEstimatedTotal(cart);
    updateCheckoutLink(cartHasNoDiscount(cart) || visualPayday ? '' : applied);

    if (couponState.inFlight) return;

    if (cartHasFestiveBundle(cart)) {
      const manual = applied && !isAutoCouponCode(applied) ? applied : '';
      updateCheckoutLink(manual);
      if (couponState.inFlight) return;
      if (manual) {
        if (couponState.appliedCode !== manual || (couponInputEl && couponInputEl.readOnly !== true)) {
          setCouponAppliedUI(manual);
        }
        return;
      }
      if (
        couponState.showingError &&
        !(couponInputEl && isAutoCouponCode(couponInputEl.value))
      ) {
        return;
      }
      if (couponInputEl && isAutoCouponCode(couponInputEl.value)) {
        couponInputEl.value = '';
        couponInputEl.readOnly = false;
      } else if (couponInputEl && document.activeElement === couponInputEl && !couponInputEl.readOnly) {
        return;
      }
      setCouponIdleUI();
      if (isAutoCouponCode(applied) && couponState.festiveCouponCleared !== applied) {
        couponState.festiveCouponCleared = applied;
        removeCoupon()
          .then((nextCart) => {
            if (nextCart) paintCart(nextCart);
          })
          .catch(() => {});
      }
      return;
    }

    if (visualPayday) {
      if (couponState.showingError) return;
      if (couponInputEl && document.activeElement === couponInputEl && !couponInputEl.readOnly) return;
      if (couponState.appliedCode !== AUTO_COUPON_CODE || (couponInputEl && !couponInputEl.readOnly)) {
        setCouponAppliedUI(AUTO_COUPON_CODE);
      }
      return;
    }

    if (cartHasNoDiscount(cart)) {
      if (couponState.showingError) return;
      if (applied || couponState.appliedCode) return;
      if (couponInputEl && document.activeElement === couponInputEl) return;
      setCouponIdleUI();
      return;
    }

    if (applied) {
      if (couponState.appliedCode !== applied || (couponInputEl && couponInputEl.readOnly !== true)) {
        setCouponAppliedUI(applied);
      }
      return;
    }

    if (couponState.showingError) return;
    if (couponInputEl && document.activeElement === couponInputEl) return;

    if (couponState.appliedCode || (couponInputEl && couponInputEl.readOnly)) {
      setCouponIdleUI();
    }
  };

  const updateCartDiscounts = async (payload) => {
    const response = await fetch(cartUpdateUrl, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    });

    const data = await response.json().catch(() => null);
    if (!response.ok || !data || data.status) {
      throw new Error(getErrorMessage(data, 'Unable to update coupon. Please try again.'));
    }
    return data;
  };

  const applyCoupon = async (code) => {
    if (cartHasNoDiscount(cachedCart)) {
      throw new Error(NO_DISCOUNT_MESSAGE);
    }
    const previous = couponState.appliedCode || '';
    const cart = await updateCartDiscounts({
      discount: code,
      attributes: { coupon_code: code },
    });

    if (!isCouponApplicable(cart, code)) {
      await updateCartDiscounts({
        discount: previous,
        attributes: { coupon_code: previous },
      }).catch(() => {});
      throw new Error('invalid');
    }

    return cart;
  };

  const removeCoupon = async () => {
    return updateCartDiscounts({
      discount: '',
      attributes: { coupon_code: '' },
    });
  };

  const handleCouponAction = async () => {
    if (!couponInputEl || !couponBtnEl || couponState.inFlight) return;

    const isRemove = couponBtnEl.classList.contains('is-remove') || couponInputEl.readOnly;
    const code = String(couponInputEl.value || '').trim();

    if (
      isRemove &&
      String(couponState.appliedCode || code).toUpperCase() === AUTO_COUPON_CODE &&
      !getAppliedCoupon(cachedCart)
    ) {
      couponState.suppressAutoCoupon = true;
      setCouponIdleUI();
      if (cachedCart) {
        updateEstimatedTotal(cachedCart);
        updateCheckoutLink('');
      }
      return;
    }

    if (!isRemove && !code) {
      setCouponErrorUI('');
      setCouponMessage('Please enter a coupon code', 'error');
      return;
    }

    if (!isRemove && cartHasNoDiscount(cachedCart)) {
      setCouponErrorUI(code, NO_DISCOUNT_MESSAGE);
      return;
    }

    couponState.inFlight = true;
    couponBtnEl.disabled = true;
    if (!isRemove) couponInputEl.readOnly = true;
    setCouponButton('loading');
    setCouponMessage('', '');
    if (couponBoxEl) couponBoxEl.classList.remove('is-error');

    try {
      if (isRemove) {
        if (String(code || '').toUpperCase() === AUTO_COUPON_CODE) couponState.suppressAutoCoupon = true;
        await removeCoupon();
        couponState.appliedCode = '';
        couponState.showingError = false;
        couponInputEl.value = '';
        couponInputEl.readOnly = false;
        setCouponButton('apply');
        if (couponBoxEl) couponBoxEl.classList.remove('is-applied', 'is-error');
        setCouponMessage('', '');
      } else {
        await applyCoupon(code);
        couponState.showingError = false;
        setCouponAppliedUI(code);
      }

      await renderCart();
    } catch (error) {
      if (isRemove) {
        setCouponAppliedUI(couponState.appliedCode || code);
        setCouponMessage(error.message || 'Unable to remove coupon. Please try again.', 'error');
        if (couponBoxEl) couponBoxEl.classList.add('is-error');
      } else {
        setCouponErrorUI(
          code,
          error.message && error.message !== 'invalid' ? error.message : undefined
        );
      }
    } finally {
      couponState.inFlight = false;
      if (couponBtnEl) couponBtnEl.disabled = false;
    }
  };

  const renderCart = async () => {
    if (!itemsEl) return null;

    checkoutCartOverride = null;
    let cart = await fetchCartState();
    if (cartHasNoDiscount(cart) && cartHasAnyDiscount(cart) && !couponState.inFlight) {
      try {
        const removedCode = getAppliedCoupon(cart) || couponState.appliedCode || '';
        cart = await removeCoupon();
        setCouponErrorUI(removedCode, NO_DISCOUNT_MESSAGE);
      } catch (error) {
        // Keep rendering the latest cart even if coupon cleanup fails.
      }
    }
    paintCart(cart);
    if (drawer.getAttribute('data-open-when-rendered') === 'true') {
      drawer.removeAttribute('data-open-when-rendered');
      const nativeDrawer = document.querySelector('cart-drawer-component');
      if (nativeDrawer && typeof nativeDrawer.close === 'function') nativeDrawer.close();
      openDrawer();
    }

    cart = await syncFreeGifts(cart);
    await ensureCartCompareAts(cart);
    paintCart(cart);

    return cart;
  };

  const changeCartItem = async (key, quantity) => {
    const response = await fetch(cartChangeUrl, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        id: key,
        quantity: quantity,
      }),
    });

    const payload = await response.json().catch(() => null);

    if (!response.ok || (payload && payload.status)) {
      throw new Error(getErrorMessage(payload, CART_UPDATE_ERROR));
    }

    return renderCart();
  };

  const isCartAddForm = (form) => {
    if (!(form instanceof HTMLFormElement)) return false;

    const actionAttr = (form.getAttribute('action') || '').split('?')[0].replace(/\/$/, '');
    if (actionAttr === '/cart/add' || actionAttr.endsWith('/cart/add')) return true;

    try {
      const pathname = new URL(form.action, window.location.origin).pathname.replace(/\/$/, '');
      return pathname === '/cart/add' || pathname.endsWith('/cart/add');
    } catch (error) {
      return false;
    }
  };

  const getSubmitButton = (form) =>
    form.querySelector('[type="submit"], button[name="add"], add-to-cart-component button');

  const getErrorElement = (form) => {
    let errorEl = form.querySelector('.' + ERROR_CLASS);
    if (errorEl) return errorEl;

    errorEl = document.createElement('p');
    errorEl.className = ERROR_CLASS;
    errorEl.setAttribute('role', 'alert');

    const button = getSubmitButton(form);
    if (button) {
      const host = button.closest('add-to-cart-component') || button;
      host.insertAdjacentElement('afterend', errorEl);
    } else {
      form.appendChild(errorEl);
    }

    return errorEl;
  };

  const showFormError = (form, message) => {
    const errorEl = getErrorElement(form);
    errorEl.textContent = message;
    errorEl.classList.add('is-visible');
  };

  const clearFormError = (form) => {
    const errorEl = form.querySelector('.' + ERROR_CLASS);
    if (!errorEl) return;
    errorEl.textContent = '';
    errorEl.classList.remove('is-visible');
  };

  const pendingAdds = new Set();
  const ADD_LOCK_MS = 900;
  let cartRefreshTimer = 0;

  const scheduleCartRefresh = () => {
    window.clearTimeout(cartRefreshTimer);
    cartRefreshTimer = window.setTimeout(() => {
      renderCart().catch(() => {});
    }, 50);
  };

  const handleCartAddSubmit = async (event) => {
    const form = event.target;
    if (!isCartAddForm(form)) return;

    // Horizon product-form already AJAX-adds on the same capture-phase submit.
    // Posting again here added quantity 2 from a single click.
    if (form.closest('product-form-component')) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();
    if (typeof event.stopImmediatePropagation === 'function') {
      event.stopImmediatePropagation();
    }

    clearFormError(form);

    const formData = new FormData(form);
    const variantId = String(formData.get('id') || '').trim();

    if (!variantId || variantId === '0') {
      showFormError(form, VARIANT_REQUIRED_MESSAGE);
      return;
    }

    const lockKey = variantId;
    if (pendingAdds.has(lockKey)) return;
    pendingAdds.add(lockKey);

    const button = getSubmitButton(form);
    if (button) button.disabled = true;

    try {
      const addResponse = await fetch(cartAddUrl, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: formData,
      });

      const addPayload = await addResponse.json().catch(() => null);

      if (!addResponse.ok || (addPayload && addPayload.status)) {
        showFormError(form, getErrorMessage(addPayload, GENERIC_ERROR_MESSAGE));
        return;
      }

      await renderCart();
    } catch (error) {
      showFormError(form, (error && error.message) || GENERIC_ERROR_MESSAGE);
    } finally {
      window.setTimeout(() => pendingAdds.delete(lockKey), ADD_LOCK_MS);
      if (button) button.disabled = false;
    }
  };

  document.addEventListener('submit', handleCartAddSubmit, true);

  document.addEventListener('cart:update', (event) => {
    const data = (event.detail && event.detail.data) || {};
    const source = data.source;

    if (drawer.getAttribute('data-open-after-add') === 'true' && source === 'product-form-component') {
      drawer.removeAttribute('data-open-after-add');
      if (!data.didError) drawer.setAttribute('data-open-when-rendered', 'true');
    }

    if (source === 'custom-cart-drawer') return;
    scheduleCartRefresh();
  });

  const isHeaderCartTrigger = (target) => {
    if (!(target instanceof Element)) return false;

    return Boolean(
      target.closest('[data-open-custom-cart-drawer]') ||
        target.closest('.header-actions__cart-icon') ||
        target.closest('[data-testid="cart-drawer-trigger"]') ||
        target.closest('a.action__cart')
    );
  };

  const handleHeaderCartClick = (event) => {
    if (event.button != null && event.button !== 0) return;
    if (!isHeaderCartTrigger(event.target)) return;

    event.preventDefault();
    event.stopPropagation();
    if (typeof event.stopImmediatePropagation === 'function') {
      event.stopImmediatePropagation();
    }

    const nativeDrawer = document.querySelector('cart-drawer-component');
    if (nativeDrawer && typeof nativeDrawer.close === 'function') {
      nativeDrawer.close();
    }

    if (cachedCart) {
      paintCart(cachedCart);
    }

    openDrawer();

    renderCart().catch(() => {});
  };

  document.addEventListener('click', handleHeaderCartClick, true);

  drawer.addEventListener('click', async (event) => {
    if (event.target.closest('[data-price-summary-close]')) {
      closePriceSummary();
      return;
    }

    if (event.target.closest('#cart-drawer-see-details')) {
      openPriceSummary();
      return;
    }

    if (event.target.closest('[data-cart-drawer-close]')) {
      closeDrawer();
      return;
    }

    const offerButton = event.target.closest('[data-offer-add]');
    if (offerButton) {
      const variantId = offerButton.getAttribute('data-variant-id');
      if (!variantId || offerButton.disabled) return;

      offerButton.disabled = true;
      const originalLabel = offerButton.textContent;
      offerButton.textContent = 'Adding';

      try {
        const addResponse = await fetch(cartAddUrl, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            id: Number(variantId),
            quantity: 1,
          }),
        });
        const addPayload = await addResponse.json().catch(() => null);
        if (!addResponse.ok || (addPayload && addPayload.status)) {
          throw new Error(getErrorMessage(addPayload, GENERIC_ERROR_MESSAGE));
        }
        await renderCart();
      } catch (error) {
        offerButton.textContent = originalLabel;
        offerButton.disabled = false;
        return;
      }

      offerButton.textContent = originalLabel;
      offerButton.disabled = false;
      return;
    }

    const minusButton = event.target.closest('[data-qty-minus]');
    const plusButton = event.target.closest('[data-qty-plus]');
    const removeButton = event.target.closest('[data-cart-remove]');

    if (!minusButton && !plusButton && !removeButton) return;

    const control = minusButton || plusButton || removeButton;
    const item = control.closest('.cart-drawer-item');
    const stepper = item && item.querySelector('.qty-stepper');
    const key = control.getAttribute('data-key') || (stepper && stepper.getAttribute('data-key'));
    if (!key || inFlightKeys.has(key)) return;

    const currentQty = parseInt(stepper && stepper.getAttribute('data-quantity'), 10) || 1;
    let nextQty;

    if (removeButton) {
      nextQty = 0;
    } else if (minusButton) {
      nextQty = currentQty <= 1 ? 0 : currentQty - 1;
    } else {
      const productId = item && item.getAttribute('data-product-id');
      const titleNode = item && item.querySelector('.cart-drawer-item__title');
      const festiveBundle = titleNode && isFestiveBundleTitle(titleNode.textContent);
      const maxQty = festiveBundle
        ? 1
        : Number(stepper && stepper.getAttribute('data-max-qty')) ||
          Number(maxQtyByProductId[String(productId || '')]) ||
          0;
      if (festiveBundle) {
        if (currentQty >= 1) return;
        nextQty = currentQty + 1;
      } else if (maxQty === 4) {
        if (currentQty >= maxQty) return;
        nextQty = currentQty + 1;
      } else {
        const productQty = getProductQtyInCart(cachedCart, productId);
        if (maxQty > 0 && productQty >= maxQty) return;
        nextQty = currentQty + 1;
      }
    }

    inFlightKeys.add(key);
    const actions = item && item.querySelector('.cart-drawer-item__actions');
    if (actions) actions.classList.add('is-updating');
    if (stepper) stepper.classList.add('is-updating');
    if (removeButton) removeButton.disabled = true;
    if (minusButton) minusButton.disabled = true;
    if (plusButton) plusButton.disabled = true;

    try {
      await changeCartItem(key, nextQty);
    } catch (error) {
      showItemError(item, error.message || CART_UPDATE_ERROR);
      if (actions) actions.classList.remove('is-updating');
      if (stepper) stepper.classList.remove('is-updating');
      if (removeButton) removeButton.disabled = false;
      if (minusButton) minusButton.disabled = false;
      if (plusButton) plusButton.disabled = false;
    } finally {
      setTimeout(() => {
        inFlightKeys.delete(key);
      }, STEPPER_LOCK_MS);
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && drawer.classList.contains('is-open')) {
      if (summaryEl && !summaryEl.hidden) {
        closePriceSummary();
        return;
      }
      closeDrawer();
    }
  });

  if (couponBtnEl) {
    couponBtnEl.addEventListener('click', handleCouponAction);
  }

  if (checkoutEl) {
    checkoutEl.addEventListener('click', startGokwikCheckout);
  }

  if (couponInputEl) {
    couponInputEl.addEventListener('keydown', (event) => {
      if (event.key !== 'Enter') return;
      event.preventDefault();
      if (couponInputEl.readOnly) return;
      handleCouponAction();
    });

    couponInputEl.addEventListener(
      'input',
      debounce(() => {
        if (!couponState.showingError) return;
        couponState.showingError = false;
        if (couponBoxEl) couponBoxEl.classList.remove('is-error');
        setCouponMessage('', '');
      }, 150)
    );
  }

  window.renderCart = renderCart;

  if (cachedCart) {
    paintCart(cachedCart);
  }
})();
